export const serverPath = "http://api.100pay.org:8080/100pay/arquivos";